import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FacilityConfigConstants {
    fcPanelHeading: string = "Facility Configuration";
    fcPanelTitle: string = "Stations";
    fcWarningTooltip: string = "All stations must be assigned to a Zone before you can save your Facility Configuration";
    fcEmptyZoneText1: string = "Create Zones and Drag Stations into Zones to setup your Facility Configuration";
    fcEmptyZoneText2: string = "All Stations Must be Assigned to a Zone to Save Configuration";
    fcAddZoneButtonText: string = "Add Zone";
    fcEmptyZoneText3: string = "To Start Configuring Facility, Click the Pencil Icon in the top Right-hand Corner";
    fcEmptyStationAreaText: string = "Drag Stations Here to Assign Them to the Zone";
    fcAllStationsInUse: string = "All Stations are assigned to a Zone in your Facility Configuration. You can now save.";
    managerWalkZoneName: string = "Manager Walk";

    //breadcrumbs
    breadcrumbTextHome: string = "CQMS";
    breadcrumbTextFacilityConfig: string = "/ Facility Configuration";
    breadcrumbTextEdit: string = " / Modify Facility Configuration";
}
